import React from 'react'
import AdmStudentConfirm from '../../components/AdminTabs/AdminStudentConfirm/AdmStudentConfirm'

const StudentConfirm = () => {
  return (
    <div>
        <AdmStudentConfirm />
    </div>
  )
}

export default StudentConfirm